<template>
    <div v-if="showElement" style="min-height:69px">
        <div style="overflow:hidden;">
            <transition name="slide">
                <div v-show="showElement" class="alert alert-warning">
                <span v-if="!locationBlocked">
                    Vandaag in de buurt een filmpje pakken? <a href="#" @click.prevent="triggerGetLocation">Zet je locatievoorziening aan</a> om de dichtsbijzijnde bioscopen te bepalen!
                </span>
                    <span v-if="locationBlocked">
                   Om bioscopen dichtbij te kunnen bepalen, hebben wij toegang nodig tot je locatievoorziening.
                </span>
                </div>
            </transition>
        </div>
    </div>


</template>

<script>
    export default {
        data() {
            return {
                showElement: false,
                locationBlocked: false,
                filtersInit: true,
            };
        },
        mounted() {
            VueEvents.$on('loaded_filters', (filters) => {
                if(this.filtersInit && !MrMovie.pageFilter.getFilters().length) {
                    this.showElement = true;
                    this.filtersInit = false;
                }

                if(MrMovie.pageFilter.getFilters().length) {
                    this.showElement = false;
                }


            });
            VueEvents.$on('location_set_in_session', location => {
                this.showElement = false;
            });

            VueEvents.$on('location-filter:blocked', location => {
                this.showElement = true;
                this.locationBlocked = true;
            });


        },
        methods: {
            /**
             * Get the location of the visitor
             * @return {void}
             */
            triggerGetLocation() {
                VueEvents.$emit('location:triggered', {'force': true});
                this.showElement= false;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/HeaderLocationTrigger.vue